import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationPage } from '../entities/notification.entity';

export interface NotificationProviderPort {
  list(init: number, limit: number): Observable<NotificationPage>;
  unreadCount(): Observable<number>;
  markAsRead(uuid: string): Observable<void>;
  markAllAsRead(): Observable<void>;
  clear(uuid: string): Observable<void>;
  clearAll(): Observable<void>;
}

export const NOTIFICATION_PROVIDER_PORT =
  new InjectionToken<NotificationProviderPort>('NOTIFICATION_PROVIDER_PORT');
